import { render, staticRenderFns } from "./User_PAW_addImages.vue?vue&type=template&id=5f8e2ebc&scoped=true&"
import script from "./User_PAW_addImages.vue?vue&type=script&lang=js&"
export * from "./User_PAW_addImages.vue?vue&type=script&lang=js&"
import style0 from "./User_PAW_addImages.vue?vue&type=style&index=0&id=5f8e2ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e2ebc",
  null
  
)

export default component.exports